/**
 * Detected OS and platform information
 */
export const getMobileOS = () => {
  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

  // iOS detection
  if (/iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream) {
    return 'iOS';
  }

  // Android detection
  if (/android/i.test(ua)) {
    return 'Android';
  }

  return 'Unknown';
};

export const isMobile = () => {
  return getMobileOS() !== 'Unknown';
};

export const IOS_APP_LINK = "https://apps.apple.com/tr/app/postac%C4%B1m/id6760547392";
export const ANDROID_APP_LINK = "https://play.google.com/store/apps/details?id=net.postacim.app&pli=1";
export const APP_SCHEME = "postacim://";
